<template>
  <SioIcon :connection-status="vConnectionStatus" :state="state" :type="type" :device-make="deviceMake" />
</template>

<script setup lang="ts">
/**
 * 1. Is Gateway Online?
 * 2. Is Device Connected?
 * TODO :: 3. Is Onboard SIO Connected?
 * TODO :: 4. Icon for Network -vs- Serial -vs- Onboard
 */
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    gatewayConnectionStatus: boolean;
    deviceConnectionStatus: string;
    connectionStatus: string;
    state: string;
    type: string;
    deviceMake?: string;
  }>(),
  {
    gatewayConnectionStatus: false,
    deviceConnectionStatus: '',
    connectionStatus: '',
    state: '',
    type: '',
    deviceMake: ''
  }
);

const vConnectionStatus = computed(() => {
  if (props.connectionStatus) {
    return props.connectionStatus;
  }

  if (!props.gatewayConnectionStatus) {
    return 'GatewayOffline';
  }

  if (props.deviceConnectionStatus) {
    return props.deviceConnectionStatus;
  }

  return 'DeviceOffline';
});
</script>
